import React from "react";
import TableOfContents from "../../../TableOfContents/TableOfContents.tsx";
import TocMobile from "../../../ToCTelephone/TocTelephone.tsx";
// import the corresponding css file
import "./EC20Experiments.css";
// import the separated file related to the component
import TextEC20Experiments from "./TextEC20Experiments.jsx";

const EC20Experiments = () => {
  // headingData is used in the TableOfContents
  // every title (h2, h3, etc) used in the separated file of the component should be in the table
  const headingsData = [
    {
      // the level 2 is the most important level you can have (the basic one)
      level: 2,
      // the text will be displayed in the table of contents
      text: "Checking that EC20 is expressed",
      // the id should be the same as the one used in the separated file of the component else the name of the title would not be displayed as wanted
      // do not use space for the id
      id: "Checking-that-EC20-is-expressed_e",
    },

    {
      level: 3,
      text: "Western Blot",
      id: "Western Blot",
    },

    {
      level: 3,
      text: "Coomassie blue staining",
      id: "coomassie",
    },

    {
      level: 3,
      text: "DTT and Urea added to the boiling step, followed by western blot",
      id: "DTT and Urea",
    },

    { level: 2, text: "Checking that EC20 is on the surface", id: "Surface_e" },

    {
      // level 3 has a specific style so the title in the TOC will be display on the right of a level 2 title
      level: 3,
      text: "Proteinase K assay",
      id: "Proteinase K assay",
    },

    {
      level: 3,
      text: "Immunofluorescence",
      id: "Immunofluorescence",
    },

    {
      level: 2,
      text: "Checking that EC20 binds to cadmium",
      id: "cadmium_e",
    },

    {
      level: 2,
      text: "References",
      id: "References",
    },
  ];

  return (
    <>
      {/* Display the content of the page on the entire viewport */}
      <div>
        {/* divide the section in columns */}
        <div className="grid grid-cols-12 gap-4" style={{ marginLeft: "50px" }}>
          {/* section on the left (=Table of content) */}
          <div className="hidden md:block col-span-4 ml-6 order-2 md:order-1">
            {/* it will stay visible on the viewport */}
            <div className="sticky top-4 scrollable">
              {/* call the Table of contents with headingData modified above */}
              <TableOfContents headings={headingsData} />
            </div>
          </div>
          {/* main content which is a separated file you call and it is displayed on the right of the section above */}
          <main className="prose col-span-12 md:col-span-8 order-1 md:order-2">
            <TextEC20Experiments />
          </main>
          {/* display the table of content when the viewport is too small */}
          <div className="md:hidden col-span-12 order-3 TOCstyle">
            <TocMobile headings={headingsData} />
          </div>
        </div>
      </div>
    </>
  );
};

// don't forget to change the name of the component you're exporting
export default EC20Experiments;
